package com.ervasstudio.tracoemovimento.components.layouts

import androidx.compose.runtime.Composable
import com.ervasstudio.tracoemovimento.components.custumcomponents.layout.AccordionItem
import com.ervasstudio.tracoemovimento.model.Paginas
import com.ervasstudio.tracoemovimento.util.rememberIsMobile
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.layout.Layout


@Layout
@Composable
/*fun PageLayout(ctx: PageContext, content: @Composable () -> Unit){

    //var expandedIndex by remember { mutableStateOf(0) }

    val items: List<Paginas> = listOf(
        Paginas.INÍCIO,
        Paginas.PROJECTO,
        Paginas.SOBRE,
        Paginas.BLOG,
        Paginas.CURSOS,
    )

    // A rota atual do contexto do Kobweb reflete automaticamente
    // o histórico do navegador (Back, Forward e Refresh).
    val currentPath = ctx.route.path

    println("Current path: $currentPath")

    // Encontra o índice ativo com base estritamente na rota atual da URL

    val expandedIndex = items.indexOfFirst { pagina ->
        if (pagina.rota == "/") {
            currentPath == "/"          // home só faz match exato
        } else {
            currentPath.startsWith(pagina.rota)   // "/blog/123" começa por "/blog/"
        }
    }.let { if (it == -1) 0 else it }


    Row(
        modifier = Modifier
            .fillMaxSize()
            .overflow(Overflow.Hidden)
    ) {
        items.forEachIndexed { index, pagina ->
            HorizontalAccordionItems(
                pagina = pagina,
                content = content,
                isExpanded = index == expandedIndex,
                onClick = { clickedPagina ->
                    // Navega usando o router do Kobweb.
                    // O Kobweb atualiza a URL e o histórico do browser automaticamente.
                    if (ctx.route.path != clickedPagina.rota) {
                        ctx.router.navigateTo(clickedPagina.rota)
                    }
                },
                backgroundColor = when (index) {
                    0 -> Paginas.INÍCIO.cor
                    1 -> Paginas.PROJECTO.cor
                    2 -> Paginas.SOBRE.cor
                    3 -> Paginas.BLOG.cor
                    4 -> Paginas.CURSOS.cor
                    5 -> Paginas.`MEUS CURSOS`.cor
                    6 -> Paginas.LOGIN.cor
                    7 -> Paginas.SIGNUP.cor
                    else -> Paginas.INÍCIO.cor
                },
                currentPath = currentPath,
            )
        }
    }
}

@Composable
fun HorizontalAccordionItems(
    pagina: Paginas,
    content: @Composable () -> Unit,
    isExpanded: Boolean,
    onClick: (pagia: Paginas) -> Unit,
    backgroundColor: CSSColorValue = Colors.LightGray,
    currentPath: String,
) {

    val itemWidth = if (isExpanded) 94.percent else 2.percent

    var htmlElement by remember { mutableStateOf<HTMLElement?>(null) }

    Row(
        modifier = Modifier
            .width(itemWidth)
            .height(100.percent)
            //.overflow(Overflow.Hidden)
            .overflow(overflowX = Overflow.Hidden, overflowY = Overflow.Auto)
            .classNames("no-scrollbar", "accordion-scroll-container")
            // ← liberta o eixo vertical
            .backgroundColor(backgroundColor)
            .position(Position.Relative)  // IMPORTANTE
            .boxSizing(BoxSizing.BorderBox)
            .padding(top = if (!isExpanded) 400.px else 0.px)
            .cursor(if (!isExpanded) Cursor.Pointer else Cursor.Default)
            .transition(
                Transition.of("width", 0.5.s, AnimationTimingFunction.EaseInOut)
            )

            .onClick { if (!isExpanded) onClick(pagina) },  // ← só navega se estiver colapsado

        horizontalArrangement = Arrangement.Center
    ) {



        if (!isExpanded) {

            SpanText(
                modifier = Modifier
                    .margin(bottom = 0.px)
                    .fontFamily("Gotham")
                    .fontSize(20.px)
                    .fontWeight(FontWeight.Medium)
                    .textOverflow(TextOverflow.Ellipsis)
                    //.overflow(Overflow.Hidden)
                    .lineHeight(1)
                    .styleModifier {
                        property("display", "-webkit-box")
                        property("-webkit-box-orient", "vertical")
                        property("transform", if (!isExpanded) "rotate(270deg)" else "rotate(0deg)")
                        property("transform-origin", "center center")


                    },
                text = pagina.name
            )

        } else {
            if(currentPath.startsWith("/cursos/") ){
                Column(modifier = Modifier.fillMaxWidth()*//*width(itemWidth)*//*){
                    HeaderCursos()
                    content()}}else{content()
            }
        }
    }
}*/
fun PageLayout(ctx: PageContext, content: @Composable () -> Unit) {

    val items: List<Paginas> = listOf(
        Paginas.INÍCIO,
        Paginas.PROJECTO,
        Paginas.SOBRE,
        Paginas.BLOG,
        Paginas.CURSOS,
    )

    val currentPath = ctx.route.path
    val isMobile = rememberIsMobile()

    val expandedIndex = items.indexOfFirst { pagina ->
        if (pagina.rota == "/") currentPath == "/"
        else currentPath.startsWith(pagina.rota)
    }.let { if (it == -1) 0 else it }

    val containerModifier = Modifier
        .fillMaxSize()
        .overflow(Overflow.Hidden)

    if (isMobile) {
        Column(modifier = containerModifier) {
            items.forEachIndexed { index, pagina ->
                AccordionItem(
                    pagina = pagina,
                    content = content,
                    isExpanded = index == expandedIndex,
                    onClick = { clicked ->
                        if (ctx.route.path != clicked.rota) ctx.router.navigateTo(clicked.rota)
                    },
                    backgroundColor = corPorIndice(index),
                    currentPath = currentPath,
                    isMobile = true,
                )
            }
        }
    } else {
        Row(modifier = containerModifier) {
            items.forEachIndexed { index, pagina ->
                AccordionItem(
                    pagina = pagina,
                    content = content,
                    isExpanded = index == expandedIndex,
                    onClick = { clicked ->
                        if (ctx.route.path != clicked.rota) ctx.router.navigateTo(clicked.rota)
                    },
                    backgroundColor = corPorIndice(index),
                    currentPath = currentPath,
                    isMobile = false,
                )
            }
        }
    }
}

private fun corPorIndice(index: Int) = when (index) {
    0 -> Paginas.INÍCIO.cor
    1 -> Paginas.PROJECTO.cor
    2 -> Paginas.SOBRE.cor
    3 -> Paginas.BLOG.cor
    4 -> Paginas.CURSOS.cor
    5 -> Paginas.`MEUS CURSOS`.cor
    6 -> Paginas.LOGIN.cor
    7 -> Paginas.SIGNUP.cor
    else -> Paginas.INÍCIO.cor
}